// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

require("@rails/ujs").start();
require("turbolinks").start();
window.$ = window.jQuery = require('jquery');
import utility from "../utility";

require("../landing/mainpage");

import CookieBanner from "../landing/cookie_banner";

import full_text_tip from "../full_text_tip";
import LandingPriceList from "../landing/landing_price";
window.LandingPriceList = new LandingPriceList();

window.sal = require("sal");

import dropdown from "./dropdown";
import landing_map from "../landing/landing_map";

window.toastr = require('toastr');
toastr.options = {
    "closeButton": true,
    "closeHtml": '<span class="cross"></span>',
    "newestOnTop": true,
    "progressBar": false,
    "positionClass": "toast-top-right",
    "preventDuplicates": false,
    "showDuration": "5000",
    "hideDuration": "1000",
    "timeOut": "5000",
    "extendedTimeOut": "1000",
    "showEasing": "swing",
    "hideEasing": "linear",
    "showMethod": "fadeIn",
    "hideMethod": "fadeOut"
};
function documentReady() {
    addActiveHeadItem();
    new CookieBanner();
    initializeLandingTableOnViewport();
    initializeLandingSliderOnViewport();
}
import PromoCodeActivator from "../landing/PromoCodeActivator";
window.PromoCodeActivator = PromoCodeActivator;

function initializeLandingTableOnViewport() {
    const table = document.querySelector("#landing-table-wrapper");
    if (!table) return;

    const loadTable = () => {
        loadLandingTableStylesheet(table.dataset.stylesheetUrl);

        import(/* webpackChunkName: "landing-main-table" */ "../landing/main_table").then(({ default: initializeLandingTable }) => {
            initializeLandingTable();
        });
    };

    if (!("IntersectionObserver" in window)) {
        loadTable();
        return;
    }

    const observer = new IntersectionObserver((entries) => {
        if (!entries.some((entry) => entry.isIntersecting)) return;

        observer.disconnect();
        loadTable();
    }, { rootMargin: "500px 0px" });

    observer.observe(table);
}

function initializeLandingSliderOnViewport() {
    const slider = document.querySelector("#landing-main-slider");
    if (!slider) return;

    const loadSlider = () => {
        import(/* webpackChunkName: "landing-main-slider" */ "../landing/main_slider").then(({ default: initializeLandingSlider }) => {
            initializeLandingSlider();
        });
    };

    if (!("IntersectionObserver" in window)) {
        loadSlider();
        return;
    }

    const observer = new IntersectionObserver((entries) => {
        if (!entries.some((entry) => entry.isIntersecting)) return;

        observer.disconnect();
        loadSlider();
    }, { rootMargin: "500px 0px" });

    observer.observe(slider);
}

function loadLandingTableStylesheet(url) {
    if (!url || document.getElementById("landing-main-table-stylesheet")) return;

    const stylesheet = document.createElement("link");
    stylesheet.id = "landing-main-table-stylesheet";
    stylesheet.rel = "stylesheet";
    stylesheet.href = url;
    document.head.appendChild(stylesheet);
}

document.addEventListener("DOMContentLoaded", documentReady);
